module.exports = "https://syscdn.233leyuan.com/233xyx-app-new/1616915989142/static/img/firstIcon.26fb55c4.svg";